export const version = '2.23.12';
